import { render } from "./TodoCardResumo.vue?vue&type=template&id=28efab48"
import script from "./TodoCardResumo.vue?vue&type=script&lang=js"
export * from "./TodoCardResumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__